<template>
  <div class="changePassword">
    <!-- 顶部导航栏 -->
    <header>
      <div class="g-header" style="background: #161936">
        <div class="left" @click="changego">
          <van-icon name="arrow-left" color="#fff" size="20px" />
        </div>
        <div class="middle fs-18">修改登录密码</div>
        <div class="right"></div>
      </div>
      <!-- <div class="blockHeight"></div> -->
    </header>
    
    <!-- 内容区域 -->
    <div class="content">
      <div class="form-container">
        <div class="input-group">
          <input 
            v-model="after_code" 
            :type="showOldPassword ? 'text' : 'password'"
            placeholder="请输入旧密码"
            class="custom-input"
          />
          <div class="eye-icon" @click="toggleOldPassword">
            <img :src="showOldPassword ? eyeOpenIcon : eyeCloseIcon" alt="toggle password" />
          </div>
        </div>
        <div class="input-group">
          <input 
            v-model="new_code" 
            :type="showNewPassword ? 'text' : 'password'"
            placeholder="请输入新密码"
            class="custom-input"
          />
          <div class="eye-icon" @click="toggleNewPassword">
            <img :src="showNewPassword ? eyeOpenIcon : eyeCloseIcon" alt="toggle password" />
          </div>
        </div>
        <div class="input-group">
          <input 
            v-model="new_codeOk" 
            :type="showConfirmPassword ? 'text' : 'password'"
            placeholder="请输入确认密码"
            class="custom-input"
          />
          <div class="eye-icon" @click="toggleConfirmPassword">
            <img :src="showConfirmPassword ? eyeOpenIcon : eyeCloseIcon" alt="toggle password" />
          </div>
        </div>
      </div>
      
      <div class="submit-container">
        <button class="submit-btn" @click="changePWD">
          提交
        </button>
      </div>
    </div>
    
    <alert-pop
      :alertType="3"
      :Tips="TipsTxt"
      v-if="PopAlert"
      @showAletfalse="showAletfalse"
    ></alert-pop>
  </div>
</template>
<script>
import AlertPop from "@/components/alert/AlertPop.vue";
import userApi from "@/api/user";
export default {
  name: "ChangePassword",
  components: { AlertPop },
  data() {
    return {
      new_code: "",
      new_codeOk: "",
      after_code: "",
      PopAlert: false,
      TipsTxt: this.$t('Tips.szcg'),
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      eyeCloseIcon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAqCAYAAAAqAaJlAAAAAXNSR0IArs4c6QAAA9xJREFUWEftl1uIHEUUhv9Ts+PIwCAGslHyoA8ixAejDC7sbbq6NwgDYrwiIQYvoAGzeVARBRNFI8qKoERR8SUQ0ReV4AXXBd06vdsDUVnIg6IgiiaQeMN4Gdd17a6jFXplXOeSYTKBQNfTUFPnnI+//3O6mnAGLTqDWJHB9utpZcpmygJZg/XLBZmymbJOgf/N2fHx8bW5XG47gHeY+VDfZOqQOAiCLSJyvjHmGQC2Kazv+3tFZKeI/ApgUxiGH59uYK31DgDPpXWrzPxeU9ggCLZZa/enB48TUdUY8+HpAg6C4I4kSV4kIgWgHsfxxiiKvmoK6za11k8AeCAFrBPRTcaYd/sN7HnefQCmiMjZ8w8AVzPz+yt1W94NtNZ7AOxKDyYAHmTmqX4AV6vVwtLS0gsicpvL7yyYy+WunZ2dnW2s1/Yio7WeBPA0gIE06ECSJNvn5+d/OFXQY2NjF+dyuZeJaCjN+SURbTbGfLq6Rsdbl+/7u0Xk0ZVAEfmeiHYw8+s9AiuttWvkx4momOYSIhpu1SNtYYMgGLLWOs+UmoBFRLTLGBN2CU1a6+tF5BEiumR1rIgcjuN4vFarHT5pZScmJi6N49gQ0RoRsUR0FxFdYK29l4jOakjEIvISEb3NzPVW4G5+K6VuJKI7AWxsOPeZUmrSWns7gK3p/hcAKsz8bUfPOh8NDAzMAVjn/E5Ek8aY511gpVLZoJR6FsDEKrA/ReQjpdQhETmadrN7IheKyOUALkvH0UrYLyIyVa/Xn1pYWPhLa+364jUA16QHPonjuBJF0fG208DzvJCIKidmG9H9xpgnVyvmed4VSqm7ReQGAPkurOAaaO/y8vK+Wq32W2OcmwqLi4tvEdGV6f5uZn6sLazWeh+AW0RkTxiGD7cD8TzPee+h9Mw3ANY3TA+3/TsAB3VeemYDM3/eKme5XC6WSqU3AYwqpa5qHF9NG6xcLudLpdJ6Zv66k2Ja68glBvAjM6/TWqskSc4lorOttfUoin72fX9IRA66XCJyTxiGbhy2XY7B2aOjZzslWvl/eHh4TaFQ+C5V8hVmvrlFrPI87xgRDQL4gJk3nWyNUwbred4WInrVJbTWbp2bmzvxu9lKrXWriCwXi8W109PT7qLU1er4UmiXzff9/SKyDUBSKBQGZ2ZmfmoD6xrRdbuzwnVhGB7oirTXD0bf999whUXEhGEYtCs+OjpayufzRwCcA+Dfa183wD0pOzIyMpjP5zenL4T/DPAWVrjITQVmdk3Z9eoJtutqPQZksD0K2DI8UzZTttc52y8FW+XNPNsvxTNlM2X/UeBvCp5xOk5aa8wAAAAASUVORK5CYII=',
      eyeOpenIcon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAABQ9JREFUWEftmGtoXEUUx/9nbtdNgglaSfCJWJFgFcQGxHWT3Lm7iFSkaiXVtlak9oN+qOCzilCsolYpBekHBa2I2odtsVSpLcjund10XZXG+sWg+AKtDzalVLeYrOu9R6bMhu1m793No4Ri5kvIznn85szMOWcu4SwZdJZwYg50pndqLqJzEZ1OBJLJ5ALf96/3fb8LQKexNSKEKJTL5SOHDh36cTr2te6Uz2gikej3fX81gCSASxuAHAWQYuatmUxmcCrQkwWlRCJxr+/76wBcE+Bw1PzeGjD/NYCNSqltALhZ6KZBHcfpYeYtAGIV48z8lxBiHzNnAOQAHFVKndTzUspzTaTjRGT7vn87EXVU6X5qWdbadDr9ZTOwTYHatv0IEb0MIGKMfkdEm5h5ewWskTMDvhLAYwCuMvJlAE8opV5tpB8Kunjx4ujo6OjbAO4xhnS0XigUCpuHh4f/aWS83vzChQvP6erqehTAMwB01KEX3NbWtvrAgQOlIJuBoD09PZH29vYPANxmjA0LIZa6rvvtVABrdRzH6WbmvQCuNnMfFYvFu4aGhnSUJ4y6oAMDA9axY8d2MfNSo7FfR7WJbRbxePxCrZPL5f4A4IctKh6Pt8+bN28nEd1q5PYope6tp1cX1LbtDUS03igfbG1tvSNsW/r6+i6yLGs9My8jovlmB44T0S7P854bHBz8PQjYHK99AG4xMs8qpTbUyk8AtW3bIaJPAFhE9MXY2JjM5/OVlDPBn5TyRgAfViX6WpkRAEuUUp8FwcZisdaWlhbFzDcA8Igo6bquziTj4zRQrRCNRvUZvAzACd/3F2Wz2Z+CHMTj8YsjkchXGpKZfR1BZv5Yy+vtNBEWAEY8z7suLLL9/f1XCCF0qjqPmX8mom6l1FjF92mgUsqnALykJ33fX5nNZreHnTEp5WsAHtSQQojlruvuqpZ3HGeZ7/s7iEjDvq6UeijMnuM4K5hZFwK90HWu674yATSZTF7ged73ekUA8kqpmxrcbmHb9og5kzuVUsvryUspd+iLyMzHM5mM7gNCL5iUMg9AH6cTpVLpynw+f/wUeMW4lHINgDfManpd19WVJnCYbf/VXJz7MpnMu/WEbdteRUTv6LlyuXxJLpf7Lcyubdt9RJQ1MmuUUltrQR8A8KZx3N+oeZg10FgsNj8ajeqtPx/A50opHf6wMTtbr4kcx3mSmXVN12OVUuq92bpMAJ5WSm2ccJn0D1LKFgDfALgcwJ9CiJ50Ov1DEOyZSk8AfimVSt3V+XtCwjcNcVonfACHi8WiPTQ09HcQ7JlI+JZl3ZxKpdxqn3VLqOM4uhxWypiuUrqyjCffWuiZLKHM/Hwmk6mU73FXQd2TcBxnJzMPGMmD5XJ5WS6XKza6YNNsSvZ2dnYO7N6926v1E9rmdXR07GHmJUZJn907lVL677RHnTZvf6FQWBrU5zbTOOuEqztzPU4y84ttbW2bw7qpsFXUa5wBvA/g/rDj1dRTxHGch5l5U9VTROdb/f+2JnrUU9z6KUJEupY/XvUU+dfU9M2NtqgpUG0kkUgs8jxvCxGN9wDTedwB0G3fWqXU4UaQer5pUGOMpJQrAOgu69oAB6HPZWYetixrYzqd1sVk5p/LtVCmedD9QdMfIIQQb6XT6UrD0UwgG6anSRnp7e1dEIlE6n7SEUIcSaVSs/dJZ1IrmQHhyZ7RGXA5NRNzoFOLW7DWXET/txH9D6XYlUnokLUqAAAAAElFTkSuQmCC'
    };
  },
  methods: {
    showAletfalse() {
      this.PopAlert = false;
      this.$router.go(-1);
    },
    changego() {
      this.$router.go(-1);
    },
    toggleOldPassword() {
      this.showOldPassword = !this.showOldPassword;
    },
    toggleNewPassword() {
      this.showNewPassword = !this.showNewPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    changePWD() {
      if (!this.after_code) {
        this.$toast(this.$t('pljiumima'));
      } else if (!this.new_code) {
        this.$toast(this.$t('plxinmima'));
      } else if (!this.new_codeOk) {
        this.$toast(this.$t('plquerenmima'));
      } else if (this.new_code != this.new_codeOk) {
        this.$toast(this.$t('Tips.buyizhi'));
      } else {
        this.$toast.loading({
          message: this.$t('jiazaizhong'),
          forbidClick: true,
          duration: 300,
        });

        userApi
          .newPass(this.new_code, this.after_code)
          .then((data) => {
            console.log(data.data);
            this.PopAlert = true;
          })
          .catch((err) => {
            this.$toast.fail(err.msg);
          });
      }
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.changePassword {
  height: 100vh;
  width: 100%;
  background: #161936;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏样式 */
.g-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  height: 60px;
  position: relative;
}

.left {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}

.middle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
}

.fs-18 {
  font-size: 18px;
}

.right {
  width: 44px;
  height: 44px;
}

.blockHeight {
  height: 20px;
}

/* 内容区域 */
.content {
  flex: 1;
  background: #050925;
  padding: 45px 68px 0;
  display: flex;
  flex-direction: column;
}

.form-container {
  // margin-bottom: 80px;
}

.input-group {
  margin-bottom: 40px;
  position: relative;
}

.custom-input {
  width: 100%;
  height: 50px;
  background: transparent;
  border: none;
  // border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  color: #ffffff;
  font-size: 16px;
  padding: 0 40px 10px 0;
  outline: none;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
    font-size: 14px;
  }
  
  &:focus {
    border-bottom-color: rgba(255, 255, 255, 0.8);
  }
}

.eye-icon {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 50px;
    // height: 20px;
    opacity: 0.6;
    transition: opacity 0.3s ease;
  }
  
  &:hover img {
    opacity: 1;
  }
}

.submit-container {
  // margin-top: auto;
  // padding-bottom: 60px;
}

.submit-btn {
  width: 100%;
  height: 50px;
  background: #0ea2ff;
  border: none;
  border-radius: 18px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: linear-gradient(90deg, #357ABD 0%, #2E6BA8 100%);
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
}
</style>